interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogType?: string;
}

const baseUrl = "https://dearyuan.cn";

export default function PageMeta({
  title,
  description,
  keywords,
  canonical,
  ogType = "website",
}: PageMetaProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={`${baseUrl}${canonical}`} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="瓜田日报" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${baseUrl}${canonical}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}